import { useMemo } from "react";
import { getDateForPriceRow } from "../../utils/methods";
import { loggerListInterface } from "./portDetailsHook";

export function useLogs(logs: loggerListInterface[]) {
  const logsFormatted = useMemo(() => {
    if (logs.length === 0) return (
        <div>No History Found</div>
    )
    return (
      <div className="scroll y">
        {logs.map((log, index) => (
          <div key={index} className="log-container">
            <p>{log.description}</p>
            <p>{`${log.name} (${log.email})`}</p>
            <p>{`Date: ${getDateForPriceRow(log.date)}`}</p>
          </div>
        ))}
      </div>
    );
  }, [logs]);
  return logsFormatted;
}
